import { render, staticRenderFns } from "./tabForm.vue?vue&type=template&id=28a3b455&scoped=true"
import script from "./tabForm.vue?vue&type=script&lang=js"
export * from "./tabForm.vue?vue&type=script&lang=js"
import style0 from "./tabForm.vue?vue&type=style&index=0&id=28a3b455&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3b455",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a3b455')) {
      api.createRecord('28a3b455', component.options)
    } else {
      api.reload('28a3b455', component.options)
    }
    module.hot.accept("./tabForm.vue?vue&type=template&id=28a3b455&scoped=true", function () {
      api.rerender('28a3b455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/contractLedger/components/tabForm.vue"
export default component.exports